import React from "react";
import styled from "styled-components";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import {useLocation, useNavigate} from "react-router-dom";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const user =     localStorage.getItem("username");
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    toggleSidebar(false);
  };

  const handleLogout = () => {
    // Clear tokens and user data
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");
    toggleSidebar(false);
    // Redirect to login page
    navigate("/login");
  };
  const handleClick = (destination) => {
    if (location.pathname !== "/") {
      navigate("/#" + destination);
    } else {
      document.getElementById(destination).scrollIntoView({ behavior: "smooth" });
    }
    toggleSidebar(false);
  }
  return (
      <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
        <SidebarHeader className="flexSpaceCenter">
          <div className="flexNullCenter"
               onClick={() => handleClick("home")}>
            <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
              Teppichhaus Hosseinzadeh
            </h1>
          </div>
          <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
            <CloseIcon />
          </CloseBtn>
        </SidebarHeader>

        <UlStyle>
          <MenuItem onClick={() => handleClick("home")}>Home</MenuItem>

          <MenuItem onClick={() => handleNavigate("/carpets")}>Teppiche</MenuItem>
          {/*<SubmenuList>*/}
          {/*  <MenuItem onClick={() => handleNavigate("/carpets")}>Modelle</MenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?model=Tabriz")}>Tabriz</SubmenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?model=Hindi")}>Hindi</SubmenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?model=Pashtu")}>Pashtu</SubmenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?model=Isfahan")}>Isfahan</SubmenuItem>*/}
          {/*</SubmenuList>*/}

          {/*<SubmenuList>*/}
          {/*  <MenuItem onClick={() => handleNavigate("/carpets")}>Maßen</MenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?size=Klein")}>Klein</SubmenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?size=Mittelgroß")}>Mittelgroß</SubmenuItem>*/}
          {/*  <SubmenuItem onClick={() => handleNavigate("/carpets?size=Groß")}>Groß</SubmenuItem>*/}
          {/*</SubmenuList>*/}

          <MenuItem onClick={() => handleClick("services")}>Leistungen</MenuItem>
          <MenuItem onClick={() => handleClick("contact")}>Kontakte</MenuItem>
          <MenuItem onClick={() => handleNavigate("/aboutUs")}>Gleitwort</MenuItem>
          {!user ?(
              <MenuItem onClick={() => handleNavigate("/login")} className="whiteColor">Anmelden</MenuItem>
          ):(

              <div>
                <MenuItem onClick={() => handleNavigate("/admin")} className="whiteColor">Banner</MenuItem>
                <MenuItem onClick={() => handleNavigate("/anleitung")} className="whiteColor">Anleitung</MenuItem>
                <MenuItem onClick={handleLogout} className="whiteColor">Abmelden</MenuItem>

            </div>

          )
          }
        </UlStyle>

      </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: ${(props) => (props.sidebarOpen ? "0" : "-400px")};
  background: #1a1a1a;
  z-index: 9999;
  transition: right 0.3s ease;
  overflow-y: auto;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

const SidebarHeader = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const CloseBtn = styled.button`
  border: 0;
  outline: none;
  background-color: transparent;
  padding: 10px;
  cursor: pointer;
`;

const UlStyle = styled.ul`
  padding: 20px;
  list-style: none;
  li {
    margin: 10px 0;
  }
`;

const MenuItem = styled.li`
  color: #f0f0f0;
  font-size: 16px;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  :hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

